import { render, staticRenderFns } from "./MessangerBanner.vue?vue&type=template&id=0b6dd6ce&scoped=true"
import script from "./MessangerBanner.vue?vue&type=script&lang=js"
export * from "./MessangerBanner.vue?vue&type=script&lang=js"
import style0 from "./MessangerBanner.vue?vue&type=style&index=0&id=0b6dd6ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6dd6ce",
  null
  
)

export default component.exports